<template>
  <div class="units-widget widget" style="position: relative">
    <div class="accordion" role="tablist">
      <div
        class="widget-header mx-auto cursor-pointer"
        v-show="isToolbarsCollapsed"
        @click.prevent="updateToolbarsStatus"
        @mouseover="increaseWidth"
        @mouseleave="resetWidth"
      >
        <img
          :src="require('@/assets/svg/tenants.svg')"
          alt="Tenants"
          :style="{ width: hoverWidth, marginInline: 'auto' }"
          v-b-tooltip.hover.right.viewport="`${$t('tenants.title_plural')}`"
        />
      </div>
      <div
        class="widget-header"
        v-show="!isToolbarsCollapsed"
      >
        <div class="icon-title" v-b-toggle="collapsible ? `main-accordion-${id}` : ''" v-if="!searchBarEnabled">
          <img
            :src="require('@/assets/svg/tenants.svg')"
            alt="Tenants"
            :style="{ width: '16px', marginInline: '16px' }"
          />
          <p class="text-center">{{ $t('tenants.title_plural') }}</p>
        </div>

        <div class="search-collapse" :class="[{ barEnable: searchBarEnabled }]">
          <img
            :src="require('@/assets/svg/search.svg')"
            alt="Search"
            :style="{ width: '18px', marginInline: '0.65rem' }"
            v-b-tooltip.hover.bottom.viewport="`${$t('search')}`"
            @click="toggleSearchBar"
            v-if="!searchBarEnabled"
          />

          <div :class="['search-bar']" v-show="searchBarEnabled">
            <div
              ref="searchBarContainer"
              class="search-bar-container d-flex align-items-center"
              :style="`width: ${searchBarWidth}px;`"
            >
              <input
                type="text"
                v-model="searchQuery"
                ref="searchBarInput"
                class="form-control"
                :placeholder="$t('grid.widgets.units.search.placeholder')"
                @input="onTypeSearch"
              />
            </div>
            <feather-icon
              icon="XIcon"
              class="cursor-pointer"
              size="16"
              @click="toggleSearchBar"
            />
          </div>
          <span class="results-count" v-show="!sidebarMinWidthReached && searchBarEnabled">{{ $t("grid.widgets.units.search.results") }}: {{ totalUnits }}</span>
        </div>

        <template v-if="collapsible">
          <feather-icon
            v-if="!isConfigModeOn && !searchBarEnabled"
            :icon="isCollapseOpen ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            v-b-toggle="collapsible ? `main-accordion-${id}` : ''"
            size="30"
          />
        </template>
        <span class="handle cursor-move" v-if="isConfigModeOn">
          <feather-icon icon="MenuIcon" size="18" />
        </span>
      </div>


      <b-collapse
        :id="`main-accordion-${id}`"
        :accordion="`main-accordion-${id}`"
        role="tabpanel"
        v-model="isCollapseOpen"
        @input="onUpdateStatus"
        v-show="isCollapseOpen && !isToolbarsCollapsed"
      >
        <div v-if="subsystemTree.length" role="tablist">
          <div
            v-for="(tenant, index) in subsystemTree"
            :key="index">
              <facilities-widget
                :tenant="tenant"
                :id-tenant="tenant.id"
                :filter="unitsResults"
                :total-units.sync="totalUnits"
                :tree-mode="TreeMode"
                :role="role"
                :parent-opened="isCollapseOpen"
                :key="`units-${tenant.name}-${tenant.id}`"
              />
          </div>
        </div>
        <div v-else class="d-flex align-content-center flex-column text-center">
          <div class="" v-if="subsystemHasNoData" ></div>
          <div class="loadingContainer" v-else>
            <SkeletonLoading :width="15" :height="15"/>
            <SkeletonLoading/>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import {
  BCollapse,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  VBToggle,
} from "bootstrap-vue";
import { debounce } from "lodash";
import store from "@/store";
import UnitsWidget from "./UnitsWidget";
import FacilitiesWidget from "./FacilitiesWidget";
import IconTenants from "@/assets/svg/tenants.svg";
import SkeletonLoading from "@/components/SkeletonLoading.vue";

export default {
  components: {
    BButton,
    BCard,
    BCardHeader,
    BCardBody,
    BCollapse,
    UnitsWidget,
    IconTenants,
    FacilitiesWidget,
    SkeletonLoading
  },
  directives: {
    "b-toggle": VBToggle,
  },
  props: {
    id: {
      required: false,
      type: Number | String,
    },
    location: {
      type: String,
      default: "bottomBar",
    },
    title: {
      type: String | Number,
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    TreeMode: {
      type: String,
      default: "widget",
    },
    role: {
      type: String,
      default: "disabled",
    },
    ignoreCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapseOpen: false,
      searchQuery: "",
      searchBarEnabled: false,
      results: [],
      tenantsResults: [],
      unitsResults: [],
      totalUnits: 0,
      searchBarWidth: 0,
      hoverWidth: "16px",
    };
  },
  mounted() {
    this.isCollapseOpen = false;

    store.dispatch("grid/getTenantsByUser");
    this.searchBarWidth = this.$el.offsetWidth - 20;
    store.dispatch("grid/loadTreeConfig");
    if (!store.state.grid.units.length) {
      store.dispatch("grid/getUnitsByTenant");
    }
  },
  methods: {
    onUpdateStatus(value) {
      this.$emit("widget-collapsed", {
        id: this.id,
        property: "isOpen",
        location: this.location,
        value,
      });
    },
    updateCollabseStatus(status, tenant) {
      if (status === "hidden") {
        store.dispatch("grid/deleteTree", tenant.id);
      } else {
        const treeConfig = store.getters["grid/getTreeById"](tenant.id);

        if (!treeConfig) {
          const payload = {
            tenantId: tenant.id,
            open: true,
            children: [],
          };
          store.dispatch("grid/addTree", payload);
        } else {
          const payload = {
            tenantId: tenant.id,
            open: true,
            entity: "tenant",
          };
          store.dispatch("grid/updateTree", payload);
        }
      }
    },
    countTenantUnits(tenantId) {
      const tenatUnits = this.units.filter((u) => u.id_tenant === tenantId);
      return tenatUnits ? tenatUnits.length : 0;
    },
    toggleSearchBar() {
      if (!this.searchBarEnabled) {
        this.searchBarEnabled = true;
        this.saveCurrentTree()
        this.$nextTick(() => {
          this.$refs.searchBarInput.focus();
        });
      } else {
        this.searchBarEnabled = false;
        this.resetSearchBar();
        this.searchQuery = "";
      }
      this.isCollapseOpen = true;
    },
    saveCurrentTree() {
      store.commit("grid/saveCurrentTree");
    },
    resetSearchBar() {
      store.commit("grid/setCurrentTreeCopy");
    },

    onTypeSearch: debounce(function () {
      if (this.searchQuery === "") {
        this.resetSearchBar();
        return;
      }
      if (this.searchQuery.length < 3) return;
      const search = this.searchQuery.toLowerCase();
      store.dispatch("grid/getFacilitiesBySearch", search);
    }, 800),

    updateToolbarsStatus() {
      store.commit(
        "psimConfig/UPDATE_TOOLBARS_COLLAPSED",
        !store.state.psimConfig.isToolbarsCollapsed
      );

      this.isCollapseOpen = true;
    },
    increaseWidth() {
      this.hoverWidth = "22px";
    },
    resetWidth() {
      this.hoverWidth = "16px";
    },
  },
  computed: {
    subsystemTree() {
      return store.getters["grid/getSubsystemTree"];
    },
    subsystemHasNoData() {
      return store.getters["grid/getDataSatus"];
    },
    tenants() {
      return store.getters["grid/getTenants"];
    },
    allTenants() {
      return store.getters["grid/getTenants"];
    },
    units() {
      return [];
    },
    isConfigModeOn() {
      return store.state.psimConfig.configModeStatus;
    },
    sidebarMinWidthReached() {
      return store.getters["grid/sidebarMinWidthReached"];
    },
    sidebarWidth() {
      return store.state.grid.sidebarWidth;
    },
    isSearching() {
      return this.searchQuery !== "";
    },
    isToolbarsCollapsed() {
      if (this.ignoreCollapse) return false;
      return store.state.psimConfig.isToolbarsCollapsed;
    },
    treeConfig() {
      const config = store.getters["grid/getAllTrees"];
      return config
        ? config.reduce((acc, item) => {
            acc[item.tenantId] = item.open;
            return acc;
          }, {})
        : null;
    },
  },
  watch: {
    sidebarWidth() {
      this.searchBarWidth = this.$el.offsetWidth - 20;
    },
    allTenants(value) {
      value.forEach((tenant) => {
        if (this.treeConfig[tenant.id]) {
          tenant.shown = this.treeConfig[tenant.id];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.units-widget .table.table-sm td {
  padding: 0 0.5rem !important;
  max-height: 70px;
}
.loadingContainer {
  display: flex;
  margin-left: 1rem;
}
.results-count {
  white-space: nowrap;
  font-size: 0.8rem;
  margin-top: 0.25rem;
  display: block;
  padding-inline: 0.5rem;
}
</style>
